import React, { ReactElement } from 'react'
import type { Nullable } from '../../types/nullable'

type DeliveryDateShortCutProps = {
  deliveryDate: Nullable<Date>;
  thisDeliveryDate: Date;
  onDeliveryDateChanged: (date: Date) => void;
}

const DeliveryDateShortCut = (
  { deliveryDate, thisDeliveryDate, onDeliveryDateChanged }: DeliveryDateShortCutProps
): ReactElement => {
  const DayI18nFormatter: Intl.DateTimeFormat = new Intl.DateTimeFormat('en-GB', { weekday: 'short' })
  const DateI18nFormatter: Intl.DateTimeFormat = new Intl.DateTimeFormat('en-GB', { month: 'short', day: 'numeric' })

  const isSelectedClass = (): 'selected' | '' => {
    if (deliveryDate && (deliveryDate.getTime() === thisDeliveryDate.getTime())) {
      return 'selected'
    }

    return ''
  }

  return (
    <button
      type="button"
      name="delivery_date"
      className={`delivery-date-shortcut ${isSelectedClass()}`}
      onClick={(): void => onDeliveryDateChanged(thisDeliveryDate)}
    >
      <span className="delivery-date-day">{DayI18nFormatter.format(thisDeliveryDate)}</span>
      <span className="delivery-date-date">{DateI18nFormatter.format(thisDeliveryDate)}</span>
    </button>
  )
}

export default DeliveryDateShortCut
